import { Stack, useTheme, useMediaQuery } from '@mui/material';
import { useBannerStore } from '@/stores/bannerStore';
import NotesHeader from '@/pages/MyNotes/components/NotesHeader/NotesHeader';
import NotesContent from '@/pages/MyNotes/components/NotesContent/NotesContent';

const SharedWithMe = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { headerHeight } = useBannerStore();

  return (
    <Stack alignItems="center" pt={4} pb={0} px={isMobile ? 2 : 4} height={`calc(100vh - ${headerHeight}px)`}>
      <NotesHeader title="Private Notes" description="Private Notes Shared With Me." />
      <NotesContent shared />
    </Stack>
  );
};

export default SharedWithMe;
